module.exports = __webpack_public_path__ + "static/media/splash3.28312b04.svg";